import {
  Popconfirm,
  Button,
  Drawer,
  message,
  Switch,
  Divider,
  notification,
} from "antd";
import {
  LogoutOutlined,
  DeleteFilled,
  ExclamationCircleFilled,
  ExclamationCircleTwoTone,
} from "@ant-design/icons";
import { useState, useContext, useEffect } from "react";
import { MyContext } from "../utils/utils";
import { db } from "../utils/firebase";
import { onValue, ref, set } from "firebase/database";
import { useParams, useNavigate } from "react-router-dom";
import styles from "./game.module.css";
const Setting = ({ visible, setVisible }) => {
  const navigate = useNavigate();
  const { currentUser } = useContext(MyContext);
  const { key } = useParams();
  const [mode, setMode] = useState({
    card: true,
    distance: true,
    turn: true,
  });
  const onClose = () => {
    setVisible(false);
  };

  const onDelete = (key) => {
    onValue(
      ref(db, "rooms/" + key + "/joiner"),
      (snapshot) => {
        const val = snapshot.val();

        for (var uid in val) {
          const userRef = ref(db, "users/" + uid + "/" + key);
          set(userRef, null);
        }
      },
      {
        onlyOnce: true,
      }
    );

    const gameRef = ref(db, "rooms/" + key);
    set(gameRef, null);
  };

  const onExit = (key) => {
    const userRef = ref(db, "users/" + currentUser.uid + "/" + key);
    const joinerRef = ref(db, "rooms/" + key + "/joiner/" + currentUser.uid);
    set(userRef, null);
    set(joinerRef, null);
    navigate("/");

    message.info("방에서 나왔습니다");
  };

  const onChange = (value, name) => {
    var temp = Object.assign({}, mode);
    if (name == "card") {
      temp.card = value;
    } else if (name == "distance") {
      temp.distance = value;
    } else if (name == "turn") {
      temp.turn = value;
    }
    set(ref(db, "rooms/" + key + "/mode"), temp);
  };

  var initial = true;
  useEffect(() => {
    onValue(ref(db, "rooms/" + key), (snapshot) => {
      const val = snapshot.val();
      if (val == null) {
        initial = true;
        message.info({ content: "게임이 종료되었습니다", key: "updateable" });
        navigate("/");
      }
    });
    onValue(ref(db, "rooms/" + key + "/mode"), (snapshot) => {
      const val = snapshot.val();
      setMode(val);
      console.log(initial);
      if (val == null) return;
      if (!initial) {
        notification.open({
          message: "게임 규칙이 변경되었습니다",
          icon: <ExclamationCircleTwoTone />,
          key: "updateable",
        });
        initial = true;
        setTimeout(() => {
          initial = false;
        }, 200);
      } else {
        initial = false;
      }
    });
  }, [db]);

  return (
    <Drawer
      width={300}
      onClose={onClose}
      visible={visible}
      bodyStyle={{ paddingBottom: 80 }}
    >
      <div className={styles.settingDiv}>
        <Divider plain>
          <b>게임 규칙 설정하기</b>
        </Divider>

        {mode && (
          <>
            <div className={styles.settings}>
              <Switch
                defaultChecked
                checked={mode.card}
                onChange={(e) => onChange(e, "card")}
              />
              <div>
                {mode.card
                  ? "카드낼 때 색상/거리 제한하기"
                  : "카드낼 때 규칙 없음"}
              </div>
            </div>

            <div className={styles.settings}>
              <Switch
                defaultChecked
                checked={mode.turn}
                onChange={(e) => onChange(e, "turn")}
              />
              <div>
                {mode.turn
                  ? "질문 받은 사람이 다음 질문하기"
                  : "방향 순서대로 돌아가기"}
              </div>
            </div>
          </>
        )}
        {mode && mode.turn && (
          <div className={styles.settings}>
            <Switch
              defaultChecked
              checked={mode.distance}
              onChange={(e) => onChange(e, "distance")}
            />
            <div>
              {mode.distance
                ? "사람 선택 시 거리 제한하기"
                : "사람 선택 시 거리 제한 없음"}
            </div>
          </div>
        )}
        <Divider></Divider>
        <Popconfirm
          placement="leftTop"
          title="정말 방에서 나갈 건가요?"
          okText="네"
          cancelText="취소"
          onConfirm={() => onExit(key)}
        >
          <Button shape="round" type="link" icon={<LogoutOutlined />} danger>
            나가기
          </Button>
        </Popconfirm>
        <Popconfirm
          placement="leftTop"
          title="정말 게임을 종료할 건가요?"
          okText="네"
          cancelText="취소"
          onConfirm={() => onDelete(key)}
        >
          <Button shape="round" type="link" icon={<DeleteFilled />} danger>
            종료하기
          </Button>
        </Popconfirm>
      </div>
    </Drawer>
  );
};

export default Setting;
